module.exports = __webpack_public_path__ + "img/ne.b1294e6d.svg";